import { alert } from "@components/common/Alert";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../hooks";
import FullScreenLoading from "../../common/loading/FullScreenLoading";

export default function SSOLogin() {
  const { reauthenticateActiveUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await reauthenticateActiveUser();
      } catch (error) {
        console.log(error);
        throw error;
      }
      navigate("/dashboard");
    })();
  }, [navigate, reauthenticateActiveUser]);

  return (
    <FullScreenLoading
      loadingTrigger={true}
      loadingText="Signing you in..."
    />
  );
}

export function SSODescopeLogin() {
  const { exchangeDescopeAuthCode } = useAuth();
  const navigate = useNavigate();
  const exchangingRef = useRef(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const descopeCode = searchParams.get("code");
    if (!descopeCode) {
      navigate("/");
      return;
    }

    if (exchangingRef.current) return;
    exchangingRef.current = true;

    // Page loaded after going through Descope SSO flow (descopeSignin()), finalize SSO login and proceed
    (async () => {
      try {
        await exchangeDescopeAuthCode(descopeCode);
        navigate("/dashboard");
      } catch {
        alert("error", "Failed to finalize authentication flow");
        navigate("/");
      }
    })();
  }, [exchangeDescopeAuthCode, navigate]);

  return (
    <FullScreenLoading
      loadingTrigger={true}
      loadingText="Signing you in..."
    />
  );
}
